import { render, staticRenderFns } from "./VerifierPage.vue?vue&type=template&id=6beaf674&scoped=true"
import script from "./VerifierPage.vue?vue&type=script&lang=js"
export * from "./VerifierPage.vue?vue&type=script&lang=js"
import style0 from "./VerifierPage.vue?vue&type=style&index=0&id=6beaf674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beaf674",
  null
  
)

export default component.exports